<template>
  <div class="v3-popup title-popup">
    <div
      class="v3-popup-mask"
      @click="v3PopupState.titlePopupState = false"
    ></div>
    <div class="v3-popup-content succ">
      <div
        class="v3-popup-content-close"
        @click="v3PopupState.titlePopupState = false"
      ></div>

      <template v-if="lotteryAndTaskState.titlePopup.title !== '無'">
        <div class="v3-popup-content-title"></div>
        <div class="award-icon-box">
          <div class="award-icon award-Title"></div>
        </div>
      </template>
      <div
        class="v3-popup-content-content"
        :style="lotteryAndTaskState.titlePopup.title !== '無' ? `color: ${lotteryAndTaskState.titlePopup.color}` : 'width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;'"
      >
        {{ lotteryAndTaskState.titlePopup.title }}
      </div>
      <div class="v3-popup-content-footer" :style="lotteryAndTaskState.titlePopup.title !== '無' ? '' : 'position: absolute; left: 50%; transform: translateX(-50%); bottom: 30px;'">
        <div
          class="confirm-btn btns"
          @click="v3PopupState.titlePopupState = false"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue";

const v3PopupState = inject("v3PopupState");
const lotteryAndTaskState = inject("lotteryAndTaskState");
</script>
